<template>
<div class="myqun sendImgs">
	<div class="headtt">
		<span class="icon iconfont" @click="go()">&#xe601;</span>
		<b @click="go()">发送多图</b>
	</div>
  <div class="ul">
	<div class="topImg">
		<el-upload
		multiple='false'
		:limit='9'
		  action=""
		  :on-change="onChange"
		  :auto-upload="false"
		  list-type="picture-card"
		  :multiple="true"
		  :on-remove="handleRemove">
		  <i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
	<div class="text" v-if="listData.length>0">
		<textarea placeholder="文案" v-model="wenAn"></textarea>
	</div>
	<div class="btn">
		  <el-button type="primary" size="medium" v-if="load" @click="goto()">发送</el-button>
		  <el-button type="primary" size="medium" v-else :loading="true">上传中</el-button>
	</div>
  </div>
</div>
</template>
<script>
import {Base64} from '@/xiaomi/Base64.js';
import {getMimcInfo} from '@/xiaomi/mimc.js';		
var qiniu = require('qiniu-js')	
import qs from "qs"	
var $this=null
export default {
	name:'sendImg',
  data () {
    return {
		getimage:'',
		suffix:'',
		suffixlist:[],
    	load:true,
	 	dialogImageUrl: '',
    	dialogVisible: false,
    	listData:'',
      	uploadArr:{
	       content:'',
	      images:[],
	      version:1,
	      reply:''
	    },
      	wenAn:'',
      	msto:'',
      	type:'',
      	hfData:'',
      	check:false,
    }
  }, 
	computed: {
	    user() {
	        return this.$store.state.user
	    }
	},   
  methods:{
  	go(){
  		this.$parent.closesenImg();
  	},
  	getDataImg(msto,type,data,check){
  		this.type=type
  		this.msto=msto
		this.hfData=JSON.parse(JSON.stringify(data))
		this.check=check
	},
	onChange(file, fileList){
		// this.getimage=file.name
		// var flieArr = this.getimage.split('.');
        //   this.suffix=flieArr[flieArr.length - 1] 
		//   this.suffixlist.push( this.suffix)
		this.listData=fileList
	},
	handleRemove(file, fileList) {
	       this.listData=fileList
	},
    times(){
          var code = "";
			    for(var i = 1;i <= 6;i++){
			        const num = Math.floor(Math.random()*10);
			         code += num;
			     };
				 var timestamp = (new Date()).valueOf();
    　　return timestamp+code
          },
 	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	    return unescape(unescape(document.cookie.substring(c_start,c_end)))
	    } 
	  }
	return ""
	},     
  goto(){
  	if(this.listData.length==0){
  		this.$message.error("请上传文件");
  		return false
  	}
  	
  	
	this.load=false  	
    for(var i=0;i<this.listData.length;i++){
      this.getUpToken(this.listData[i].raw,i)
    }
  },
  getUpToken(imgPath,i){  	
			this.$axios.defaults.headers.common['token'] = this.getCookie("mytoken")
			this.$axios.post('/goods/file/v1/getQiNiuToken?'+'r='+this.randomString(6))
			.then(userData=>{
			       if(userData.data.resultCode="0000"){
			          var uptoken=userData.data.resultInfo
			          this.uploadImg(imgPath,uptoken,i)
			       }else{
			        this.$message.error(userData.data.resultMsg);
			       }
			}).catch(error=>{
				console.log(error)
			})   	
  	  
  },
  uploadImg(imgPath,uptoken,i){
    // 交给七牛上传
	
    var flieArr = imgPath.name.split('.');
          			$this.suffix=flieArr[flieArr.length - 1] 
			var config = {useCdnDomain: false,region: null};
			var putExtra = {
						fname: "main_index_ormal",
						params: {},
						mimeType:  ["image/png", "image/jpeg", "image/gif"]
				};
				var _self=this
				
			var observer = {
			  next(res){
			   
			  },
			  error(err){
			  	$this.load=false  	
				$this.$message.error("上传失败了");
			  }, 
			  complete(res){
						  var myurl='http://img.kh507.com/'+res.key
					    $this.uploadArr.images.push(myurl)
					    $this.uploadArr.content=$this.wenAn
					    if($this.listData.length==$this.uploadArr.images.length){
						      var reply=''
						      if($this.hfData!=''){
						      
						        if($this.hfData.msg_content.content!=undefined){
						          $this.hfData.msg_content.content=$this.encodeUnicode($this.hfData.msg_content.content)
						        }   
						        delete $this.hfData.msg_content.reply
						        reply={
						          id:$this.hfData.msg_id,
						          nick_name:$this.hfData.msg_from_nick,
						          logo:$this.hfData.msg_from_logo,
						          biz_type:$this.hfData.biz_type,
						          msg_content:$this.hfData.msg_content,
						        }
						      }					    	
					      if($this.uploadArr.content!=''){
					        $this.uploadArr.content= $this.encodeUnicode($this.uploadArr.content) 
					      }
					    var show_list=''
					    var show_type='all'
					    if($this.check){
					      show_type='list'
					      show_list='['+JSON.parse($this.getCookie("userInfo")).conNum+']'
					    }	
					    $this.uploadArr.show_list=show_list
					    $this.uploadArr.show_type=show_type
					    $this.uploadArr.reply=reply
					      var message_ =Base64.encode(JSON.stringify($this.uploadArr));
					 
					      var timestampUser=String(new Date().valueOf())
					      var jsonMsg = String(JSON.stringify({ 
					          version: 0, 
					          msgId: $this.randomString(30)+"_"+1, 
					          timestamp:timestampUser, 
					          payload: message_, 
					          nickname:JSON.parse($this.getCookie("userInfo")).title,
						      logo:JSON.parse($this.getCookie("userInfo")).logo,
						      conNum:JSON.parse($this.getCookie("userInfo")).conNum
					        }));

							 if($this.type=='1'){
							 	$this.user.sendGroupMessage($this.msto,jsonMsg,"PIC_FILES"); 
							 }else if($this.type=='0'){
							 	$this.user.sendMessage($this.msto,jsonMsg,"PIC_FILES"); 
							 }else if($this.type=='2'){
							 	$this.user.sendUnlimitedGroupMessage($this.msto,jsonMsg,"PIC_FILES"); 
							 }
							$this.uploadArr.show=true
					    $this.$parent.sendImgDatas($this.uploadArr);
					    $this.$parent.closesenImg();								 
					   }
				    
					    
					    
			  }
			}
			var name=$this.createRandomId()
			// var name=$this.createRandomId()+imgPath.name;	
		var observable = qiniu.upload(imgPath,name,uptoken,putExtra,config)
		var subscription = observable.subscribe(observer) // 上传开始    
    
  },
   	createRandomId() {
            // return (Math.random()*10000000).toString(16).substr(0,4)+'_'+(new Date()).getTime()+'_'+Math.random().toString().substr(2,5);
			// return 'images/mimc/'+$this.times()+'.'+$this.suffix;
			return 'images/mimc/'+$this.times()+'.'+$this.suffix;
		} ,
  encodeUnicode(str) {
    //加码
    var res = [];
    for (var i = 0; i < str.length; i++) {
        res[i] = ( "000" + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return "\\u" + res.join("\\u");
  },
  decodeUnicode(str) { 
    //解码
    str = str.replace(/\\/g, "%"); return unescape(str);
  },
  timestamp(data){
    data=data+''
    if(data.indexOf('-')!='-1'){
      let d = new Date(data)
     data = d.getTime(d)
    }
    
   var dateCurrent = new Date();
   var yCurrent=dateCurrent.getFullYear();
   var mCurrent=dateCurrent.getMonth()+1;
   var dCurrent=dateCurrent.getDate(); 			
    var date = new Date(parseInt(data));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M = date.getMonth()+1;
    var D = date.getDate();
    var h = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    if(Y==yCurrent&&M==mCurrent&&D==dCurrent){
     if(h<10){
       h='0'+h
     }
     if(m<10){
      m='0'+m
    }
       return h+":"+m;
    }else if(Y==yCurrent&&M==mCurrent&&dCurrent-D==1){
      return "昨天";
    }else if(Y==yCurrent&&M==mCurrent&&dCurrent-D==2){
      return "前天";
    }else if(Y==yCurrent&&M==mCurrent&&dCurrent-D>2){
      return M+"月"+D+"日";
    }else if(Y==yCurrent&&M<mCurrent){
     return M+"月"+D+"日";
    }else if(Y<yCurrent){
      return Y+"年"+M+"月"+D+"日";
    }
            
  },
  time(){
    var dateCurrent = new Date();
    var yCurrent=dateCurrent.getFullYear();
    var mCurrent=dateCurrent.getMonth()+1;
    var dCurrent=dateCurrent.getDate(); 
    if(mCurrent<10){
      mCurrent="0"+mCurrent
    }
    if(dCurrent<10){
      dCurrent="0"+dCurrent
    }
    return yCurrent+mCurrent+dCurrent
    
  },
  randomString(len) {
   　　len = len || 32;
   　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
   　　var maxPos = $chars.length;
   　　var pwd = '';
   　　for (var i = 0; i < len; i++) {
   　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
   　　}
    　　return pwd;
    },    
 },
 created:function(){
	$this=this
 }
}
</script>
<style scoped>

.loding{
	position: absolute;
	left: 0;
	top: 35px;
	width: 100%;
	height: 250px;
	background: #FFFFFF;
}	
.headtt{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	cursor: pointer;
	padding: 10px;
}	
.myqun{
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	z-index: 1000;
	background: #FFFFFF;
	overflow: auto;
	padding: 15px;
	padding-top: 40px;
}
.head{
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
}
.myqun .ul{
	
}
.myqun .ul .li{
  display: flex;
  padding: 0px 25px;
  line-height: 50px;
  align-items: center;
  border-bottom: 1px #f1f1f1 solid;
}
.myqun .ul .li img{
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.myqun .ul .li .name{
  padding-left: 25px;
}
.topImg{
	padding: 20px 10px;
}
.text{
	padding: 10px;
	box-sizing:border-box ;
}
.text textarea{
	border: 1px #DFDFDF solid;
	width: 100%;
	height: 120px;
	padding: 15px;
	box-sizing:border-box ;
	font-size: 14px;
}
.btn{
	padding: 10px;
	
}




	
</style>


// WEBPACK FOOTER //
// src/components/im/sendImg.vue